{{#if hasProtocolChecker}}
virtual function bit has_protocol_checks_enabled();
  return {{ protocolCheckerBoundVariable.identifier }} && {{ protocolChecksEnabledVariable.identifier }};
endfunction
{{/if}}
